import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M0 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8m1.6 0c0 3.529 2.871 6.4 6.4 6.4s6.4-2.871 6.4-6.4S11.529 1.6 8 1.6A6.407 6.407 0 0 0 1.6 8m4.833-2.9c0-.398.165-.78.459-1.06.294-.282.692-.44 1.108-.44.415 0 .814.158 1.107.44.294.28.46.662.46 1.06v.3h.626v-.3c0-.557-.231-1.091-.642-1.485A2.24 2.24 0 0 0 8 3c-.582 0-1.14.221-1.551.615A2.06 2.06 0 0 0 5.806 5.1v.3h.627zm-1.94 1.7a.9.9 0 0 1 .307-.57.96.96 0 0 1 .627-.23h5.145c.231 0 .455.082.627.23.172.147.281.35.307.57l.488 4.2a.87.87 0 0 1-.234.7.9.9 0 0 1-.316.222 1 1 0 0 1-.384.078H4.94a1 1 0 0 1-.384-.079.9.9 0 0 1-.317-.221.863.863 0 0 1-.234-.7zm2.33 2.796L5.5 8.182l-.813.872 2.138 2.282 3.862-4.13-.814-.87z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }